function addMouseWheelListener(handler) {
    const data = {direction: 0};

    if (window.onmousewheel !== undefined) {
        // IE9+, Chrome, Safari, Opera
        const callback = ev => {
            data.direction = ev.wheelDelta > 0 ? 1 : -1;
            handler(ev, data);
        };

        window.addEventListener("mousewheel", callback, {passive: false}); // set passive to false make ev.preventDefault can work

        return callback;
    }

    // Firefox
    const callback = ev => {
        data.direction = ev.detail < 0 ? 1 : -1;
        handler(ev, data);
    };

    window.addEventListener("DOMMouseScroll", callback);

    return callback;
}

function removeMouseWheelListener(callback) {
    if (window.onmousewheel !== undefined) {
        // IE9+, Chrome, Safari, Opera
        window.removeEventListener("mousewheel", callback, {passive: false});
        return;
    }

    // Firefox
    window.removeEventListener("DOMMouseScroll", callback);
}

export {
    addMouseWheelListener,
    removeMouseWheelListener
}
